// Nombre de un agente: las mismas reglas al crearlo (NewAgentModal) y al cambiarlo (RenameAgentModal).
export const AGENT_NAME_MIN = 2;
export const AGENT_NAME_MAX = 120;

/** Quita espacios de más (también los repetidos por dentro). */
export const cleanAgentName = (raw) => String(raw ?? '').replace(/\s+/g, ' ').trim();

/** { name, error }: `error` es un texto listo para mostrar, o '' si el nombre sirve. `current` evita «cambiar» a lo mismo. */
export function checkAgentName(raw, current = '') {
  const name = cleanAgentName(raw);
  if (name.length < AGENT_NAME_MIN) return { name, error: `Escribe un nombre de al menos ${AGENT_NAME_MIN} letras.` };
  if (name.length > AGENT_NAME_MAX) return { name, error: `El nombre no puede pasar de ${AGENT_NAME_MAX} caracteres.` };
  if (name === cleanAgentName(current)) return { name, error: 'Ese ya es el nombre del agente.' };
  return { name, error: '' };
}
